/* MP — pocket printer theme scripts (vanilla, no dependencies) */
(function () {
  'use strict';
  if (window.__mpLoaded) return;
  window.__mpLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function initReveal() {
    var els = document.querySelectorAll('.mp-reveal:not(.mp-visible), .mp-mark:not(.mp-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mp-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mp-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-mp-count]:not([data-mp-counted])');
    if (!els.length) return;
    var run = function (el) {
      el.setAttribute('data-mp-counted', '');
      var target = parseFloat(el.getAttribute('data-mp-count')) || 0;
      if (reduceMotion) { el.textContent = target; return; }
      var start = null;
      var step = function (ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / 1400, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { run(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initTabs() {
    document.querySelectorAll('[data-mp-tabs]').forEach(function (wrap) {
      if (wrap.dataset.mpReady) return;
      wrap.dataset.mpReady = '1';
      var tabs = wrap.querySelectorAll('[role="tab"]');
      var panels = wrap.querySelectorAll('[role="tabpanel"]');
      var activate = function (i, focus) {
        tabs.forEach(function (t, j) {
          t.setAttribute('aria-selected', j === i ? 'true' : 'false');
          t.tabIndex = j === i ? 0 : -1;
        });
        panels.forEach(function (p, j) { p.classList.toggle('is-active', j === i); p.hidden = j !== i; });
        if (focus) tabs[i].focus();
      };
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(i); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') activate((i + 1) % tabs.length, true);
          if (e.key === 'ArrowLeft') activate((i - 1 + tabs.length) % tabs.length, true);
        });
      });
      activate(0);
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-mp-gallery]').forEach(function (g) {
      if (g.dataset.mpReady) return;
      g.dataset.mpReady = '1';
      var slides = g.querySelector('.mp-gallery__slides');
      var thumbs = g.querySelectorAll('.mp-gallery__thumb');
      var dots = g.querySelectorAll('.mp-gallery__dots span');
      if (!slides) return;
      var setActive = function (i) {
        thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      };
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          slides.scrollTo({ left: slides.clientWidth * i, behavior: reduceMotion ? 'auto' : 'smooth' });
          setActive(i);
        });
      });
      var ticking = false;
      slides.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          setActive(Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1)));
          ticking = false;
        });
      });
      g.goToMedia = function (mediaId) {
        var target = g.querySelector('[data-media-id="' + mediaId + '"]');
        if (!target) return;
        var i = Array.prototype.indexOf.call(slides.children, target);
        if (i < 0) return;
        slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' });
        setActive(i);
      };
    });
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var fmt = format || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (key === 'amount_with_comma_separator') return value.replace('.', ',');
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-mp-product]').forEach(function (wrap) {
      if (wrap.dataset.mpReady) return;
      wrap.dataset.mpReady = '1';
      var dataEl = wrap.querySelector('[data-mp-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var moneyFormat = wrap.getAttribute('data-money-format');
      var idInputs = document.querySelectorAll('[data-mp-variant-id="' + wrap.id + '"]');
      var fieldsets = wrap.querySelectorAll('.mp-opt');
      var priceNow = wrap.querySelectorAll('[data-mp-price]');
      var priceWas = wrap.querySelector('[data-mp-compare]');
      var save = wrap.querySelector('[data-mp-save]');
      var buttons = document.querySelectorAll('[data-mp-add="' + wrap.id + '"]');
      var gallery = wrap.querySelector('[data-mp-gallery]');
      var bundle = wrap.querySelector('[data-mp-bundle]');
      var bundleVariants = bundle ? JSON.parse(bundle.querySelector('[data-mp-bundle-variants]').textContent) : [];
      var sticky = document.querySelector('[data-mp-sticky] [data-mp-price]');
      if (sticky) priceNow = Array.prototype.slice.call(priceNow).concat([sticky]);

      var update = function () {
        // Tint the style previews (full / trim) with the chosen color.
        var sw = wrap.querySelector('.mp-opt input:checked + [data-mp-swatch]');
        if (sw) wrap.style.setProperty('--mp-sel', sw.getAttribute('data-mp-swatch'));
        var selected = Array.prototype.map.call(fieldsets, function (fs) {
          var c = fs.querySelector('input:checked');
          var out = fs.querySelector('legend b');
          if (c && out) out.textContent = c.value;
          return c ? c.value : null;
        });
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return o === selected[i]; });
        });
        // Combination doesn't exist (e.g. White + Color trim): jump to the closest one that does.
        if (!v && selected[0] !== null) {
          var alt = variants.find(function (x) { return x.available && x.options[0] === selected[0]; }) ||
                    variants.find(function (x) { return x.options[0] === selected[0]; });
          if (alt) {
            Array.prototype.forEach.call(fieldsets, function (fs, i) {
              fs.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === alt.options[i]; });
            });
            return update();
          }
        }
        // Grey out values that don't exist (or are sold out) with the other current choices.
        Array.prototype.forEach.call(fieldsets, function (fs, idx) {
          fs.querySelectorAll('input').forEach(function (inp) {
            // First option (color) only greys out if it doesn't exist at all; later options depend on earlier choices.
            var ok = variants.some(function (x) {
              return x.available && x.options.every(function (o, i) {
                if (i === idx) return o === inp.value;
                return i < idx ? o === selected[i] : true;
              });
            });
            var lab = inp.nextElementSibling;
            if (lab) lab.classList.toggle('is-unavailable', !ok);
          });
        });
        // Bundle picker: buy the same color/style of the bundle product instead (e.g. Starter Kit).
        // If the kit doesn't come in this color, the kit choice is disabled rather than selling another color.
        var sell = v;
        if (v && bundle) {
          var match = bundleVariants.find(function (b) { return b.options.join('/') === v.options.join('/'); });
          var kitInput = bundle.querySelector('input[value="kit"]');
          var kitOpt = kitInput.closest('.mp-bundle__opt');
          kitInput.disabled = !match;
          kitOpt.classList.toggle('is-unavailable', !match);
          if (!match && kitInput.checked) bundle.querySelector('input[value="single"]').checked = true;
          if (match && kitInput.checked) sell = match;
          // The bundle already includes paper: hide the roll-pack add-on while it's chosen.
          var addonBox = wrap.querySelector('.mp-addon');
          if (addonBox) {
            var bundleOn = match && kitInput.checked;
            addonBox.hidden = !!bundleOn;
            if (bundleOn) addonBox.querySelector('[data-mp-addon-check]').checked = false;
          }
        }
        buttons.forEach(function (b) {
          var label = b.querySelector('[data-mp-label]') || b;
          if (!sell) { b.disabled = true; label.textContent = b.getAttribute('data-unavailable'); return; }
          b.disabled = !sell.available;
          label.textContent = sell.available ? b.getAttribute('data-add') : b.getAttribute('data-soldout');
        });
        if (!v) return;
        idInputs.forEach(function (inp) { inp.value = sell.id; });
        priceNow.forEach(function (el) { el.textContent = formatMoney(sell.price, moneyFormat); });
        if (priceWas) {
          var onSale = sell.compare_at_price && sell.compare_at_price > sell.price;
          priceWas.hidden = !onSale;
          if (onSale) priceWas.textContent = formatMoney(sell.compare_at_price, moneyFormat);
          if (save) {
            save.hidden = !onSale;
            if (onSale) save.textContent = save.getAttribute('data-template').replace('[amount]', formatMoney(sell.compare_at_price - sell.price, moneyFormat));
          }
        }
        if (v.featured_media && gallery && gallery.goToMedia) gallery.goToMedia(v.featured_media.id);
        if (window.history.replaceState && window.location.pathname.indexOf('/products/') > -1) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      };
      wrap.addEventListener('change', function (e) { if (e.target.closest('.mp-opt') || e.target.closest('[data-mp-bundle]')) update(); });
      if (fieldsets.length || bundle) update();
    });
  }

  function initQty() {
    document.querySelectorAll('[data-mp-qty]').forEach(function (q) {
      if (q.dataset.mpReady) return;
      q.dataset.mpReady = '1';
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = b.dataset.step === 'up' ? v + 1 : Math.max(1, v - 1);
          input.value = v;
        });
      });
    });
  }

  function refreshCartBubble() {
    return fetch(root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !data['cart-icon-bubble']) return;
        var tmp = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
        var inner = tmp.querySelector('.shopify-section');
        bubble.innerHTML = inner ? inner.innerHTML : tmp.body.innerHTML;
      })
      .catch(function () {});
  }

  function showToast(title) {
    var toast = document.getElementById('mp-toast');
    if (!toast) { window.location.href = root + 'cart'; return; }
    var t = toast.querySelector('[data-mp-toast-title]');
    if (t && title) t.textContent = title;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () { toast.classList.remove('is-visible'); }, 6000);
  }

  function initAjaxAdd() {
    document.querySelectorAll('form[data-mp-ajax], form.mp-ajax-form').forEach(function (form) {
      if (form.dataset.mpReady) return;
      form.dataset.mpReady = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
        var fd = new FormData(form);
        var qtyForm = form.getAttribute('data-mp-qty-from');
        if (qtyForm) {
          var qtyInput = document.getElementById(qtyForm);
          if (qtyInput) fd.set('quantity', qtyInput.value);
        }
        var request = { method: 'POST', headers: { Accept: 'application/json' }, body: fd };
        // Optional add-on (e.g. paper rolls) goes in the same request.
        var addon = form.querySelector('[data-mp-addon-check]');
        var addonVariant = form.querySelector('[data-mp-addon-variant]');
        if (addon && addon.checked && addonVariant) {
          request.headers['Content-Type'] = 'application/json';
          var main = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
          if (fd.get('selling_plan')) main.selling_plan = Number(fd.get('selling_plan'));
          request.body = JSON.stringify({ items: [
            main,
            { id: Number(addonVariant.value), quantity: Number(addonVariant.dataset.qty || 1) }
          ] });
        }
        fetch(root + 'cart/add.js', request)
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Error');
            var added = res.body.items ? res.body.items.map(function (it) { return it.product_title; }).join(' + ') : (res.body.product_title || res.body.title);
            return refreshCartBubble().then(function () { showToast(added); });
          })
          .catch(function (err) {
            var msg = form.querySelector('[data-mp-error]');
            if (msg) { msg.textContent = err.message; msg.hidden = false; }
            else { form.removeAttribute('data-mp-ajax'); form.submit(); }
          })
          .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
      });
    });
    var toast = document.getElementById('mp-toast');
    if (toast && !toast.dataset.mpReady) {
      toast.dataset.mpReady = '1';
      toast.querySelector('.mp-toast__close').addEventListener('click', function () { toast.classList.remove('is-visible'); });
    }
  }

  function initSticky() {
    var bar = document.querySelector('[data-mp-sticky]');
    var anchor = document.querySelector('[data-mp-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window) || bar.dataset.mpReady) return;
    bar.dataset.mpReady = '1';
    var footer = document.querySelector('.mp-footer, footer');
    var anchorGone = false;
    var footerSeen = false;
    var sync = function () { bar.classList.toggle('is-visible', anchorGone && !footerSeen); };
    new IntersectionObserver(function (entries) {
      anchorGone = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      sync();
    }).observe(anchor);
    if (footer) new IntersectionObserver(function (entries) { footerSeen = entries[0].isIntersecting; sync(); }).observe(footer);
  }

  function initNewsletter() {
    document.querySelectorAll('.mp-news form').forEach(function (form) {
      if (form.dataset.mpReady) return;
      form.dataset.mpReady = '1';
      var ok = form.parentElement.querySelector('.mp-news__ok');
      if (ok && window.location.search.indexOf('customer_posted=true') > -1) { ok.hidden = false; form.hidden = true; }
    });
  }

  // Muted loop videos: play only while on screen, pause button for accessibility.
  function initVideos() {
    document.querySelectorAll('[data-mp-video]').forEach(function (wrap) {
      if (wrap.dataset.mpReady) return;
      wrap.dataset.mpReady = '1';
      var video = wrap.querySelector('video');
      var btn = wrap.querySelector('[data-mp-video-toggle]');
      if (!video) return;
      video.muted = true;
      video.setAttribute('playsinline', '');
      var userPaused = reduceMotion;
      var setBtn = function (paused) {
        if (!btn) return;
        btn.classList.toggle('is-paused', paused);
        btn.setAttribute('aria-label', paused ? btn.dataset.play : btn.dataset.pause);
      };
      var tryPlay = function () {
        var p = video.play();
        if (p && p.catch) p.catch(function () { setBtn(true); });
        setBtn(false);
      };
      setBtn(userPaused);
      if (btn) btn.addEventListener('click', function () {
        if (video.paused) { userPaused = false; tryPlay(); }
        else { userPaused = true; video.pause(); setBtn(true); }
      });
      if (!('IntersectionObserver' in window)) { if (!userPaused) tryPlay(); return; }
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { if (!userPaused) tryPlay(); }
        else if (!video.paused) { video.pause(); }
      }, { threshold: 0.25 }).observe(wrap);
    });
  }

  // Estimated delivery window from today, counting business days (Mon–Fri).
  function initEta() {
    document.querySelectorAll('[data-mp-eta]').forEach(function (li) {
      var add = function (n) {
        var d = new Date();
        while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
        return d;
      };
      var fmt = { month: 'short', day: 'numeric' };
      var a = add(parseInt(li.dataset.min, 10) || 8).toLocaleDateString('en-US', fmt);
      var b = add(parseInt(li.dataset.max, 10) || 18).toLocaleDateString('en-US', fmt);
      li.querySelector('[data-mp-eta-range]').textContent = a + ' – ' + b;
      li.hidden = false;
    });
  }

  // Quantity tier pills (1 / 3 / 6 rolls) set the quantity field.
  function initTiers() {
    document.querySelectorAll('[data-mp-tiers]').forEach(function (box) {
      if (box.dataset.mpReady) return;
      box.dataset.mpReady = '1';
      var qty = document.getElementById(box.dataset.qtyTarget);
      box.querySelectorAll('.mp-tier').forEach(function (btn) {
        btn.addEventListener('click', function () {
          box.querySelectorAll('.mp-tier').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          if (qty) qty.value = btn.dataset.qty;
        });
      });
    });
  }

  // Kit links (?kit=1) arrive with the paper-pack add-on already ticked.
  function initKitParam() {
    if (/[?&]bundle=/.test(window.location.search)) return initBundleParam();
    if (!/[?&]kit=/.test(window.location.search)) return;
    document.querySelectorAll('[data-mp-addon-check]').forEach(function (c) { c.checked = true; });
  }

  // Sticker Bundle links (?bundle=1): the add-on becomes a fixed number of one pack (the discount is automatic in Shopify).
  function initBundleParam() {
    document.querySelectorAll('.mp-addon[data-bundle-variant]').forEach(function (box) {
      var select = box.querySelector('[data-mp-addon-variant]');
      select.value = box.dataset.bundleVariant;
      select.dataset.qty = box.dataset.bundleQty;
      select.hidden = true;
      box.querySelector('[data-mp-addon-check]').checked = true;
      box.querySelector('.mp-addon__title').textContent = box.dataset.bundleTitle;
      var price = box.querySelector('.mp-addon__price');
      price.textContent = '';
      var b = document.createElement('b'); b.textContent = box.dataset.bundlePrice;
      var s = document.createElement('s'); s.textContent = box.dataset.bundleFull;
      price.append(b, s, ' · ' + box.dataset.bundleNote);
    });
  }

  function initAll() {
    initTiers();
    initEta();
    initVideos();
    initReveal();
    initCountUp();
    initTabs();
    initGallery();
    initVariants();
    initQty();
    initAjaxAdd();
    initSticky();
    initNewsletter();
    initKitParam();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
